import React from 'react';

import {Button, Icon, Skeleton} from '@albert-io/atomic';

// Mirrors the loaded banner's layout and height (name on the left, Invite control on the right; the
// masked Invite button sets the row height to match), so it swaps in place with no shift or white
// flash while the class loads.
export const ClassHeaderSkeleton = () => (
  <div aria-busy='true' className='shrink-0'>
    <header className='background-subtle gap-x2 px-x4 py-x6 flex min-h-[92px] items-center'>
      {/* Only the bar is capped, not the column, or Invite lands mid-header and jumps on reveal. */}
      <div className='min-w-x0 flex grow flex-col items-start'>
        <Skeleton className='h-x3 w-full max-w-[240px] rounded-full' />
      </div>
      <div className='shrink-0'>
        <Skeleton>
          <Button roundness='pill'>
            <Icon className='mr-x1' icon='user-plus' />
            Invite
          </Button>
        </Skeleton>
      </div>
      <span className='sr-only' role='status'>
        Loading class…
      </span>
    </header>
  </div>
);

/** Generic body placeholder shared by every class tab while the class loads. */
export const ClassDetailContentSkeleton = () => (
  <div aria-busy='true' className='gap-x3 pt-x4 flex flex-col'>
    <span className='sr-only' role='status'>
      Loading…
    </span>
    <Skeleton className='h-x4 w-[200px] rounded-full' />
    <div aria-hidden='true' className='gap-x2 flex flex-col'>
      {['r1', 'r2', 'r3', 'r4', 'r5', 'r6'].map((key) => (
        <Skeleton className='h-x8 rounded-x1 w-full' key={key} />
      ))}
    </div>
  </div>
);
